import { ColocaStepper } from "@/shared/components/navigation/ColocaStepper";
import useTranslations from "@/shared/lang/useTranslations";

import { PayoutBatchStatus } from "../../types/payoutBatches.types";
import { isExecutionStatus } from "../../utils/batchStatus";

export interface BatchStepperProps {
  status: PayoutBatchStatus;
  className?: string;
}

/**
 * Configure → Review → Approval → Payment, resolved from the batch status so a deep link lands on the right
 * step.
 */
export function BatchStepper({ status, className }: BatchStepperProps) {
  const { t } = useTranslations("payoutBatches");
  const currentStep = isExecutionStatus(status)
    ? 3
    : status === PayoutBatchStatus.PENDING_APPROVAL
      ? 2
      : status === PayoutBatchStatus.READY || status === PayoutBatchStatus.VALIDATING
        ? 1
        : 0;
  return (
    <ColocaStepper
      steps={[
        { label: t("step_configure") },
        { label: t("step_review") },
        { label: t("step_approval") },
        { label: t("step_confirm") },
      ]}
      currentStep={currentStep}
      aria-label={t("setup_title")}
      className={className}
    />
  );
}
